/* Source: /tmp/jacbuilder-deploy-scratch/deploy-8asygg26/features/media/MediaTab.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { SectionHeading } from "../../components/shared/Display.js";
import { __jacCallFunction } from "@jac/runtime";
import { Button } from "../../components/ui/button.js";
import { useState } from "@jac/runtime";
import { _jac } from "@jac/prelude";
async function upload_image(incident, filename, source_reference, data_url) {
  return await __jacCallFunction("upload_image", {"incident": incident, "filename": filename, "source_reference": source_reference, "data_url": data_url});
}
async function list_incident_media(incident) {
  return await __jacCallFunction("list_incident_media", {"incident": incident});
}
async function check_media_duplicates(incident) {
  return await __jacCallFunction("check_media_duplicates", {"incident": incident});
}
async function edit_media(media_id, incident, display_name, source_reference, description) {
  return await __jacCallFunction("edit_media", {"media_id": media_id, "incident": incident, "display_name": display_name, "source_reference": source_reference, "description": description});
}
async function delete_media(media_id, incident) {
  return await __jacCallFunction("delete_media", {"media_id": media_id, "incident": incident});
}
async function add_media_comment(media_id, incident, body, author) {
  return await __jacCallFunction("add_media_comment", {"media_id": media_id, "incident": incident, "body": body, "author": author});
}
async function add_media_assertion(media_id, incident, assertion_type, value, source, provenance) {
  return await __jacCallFunction("add_media_assertion", {"media_id": media_id, "incident": incident, "assertion_type": assertion_type, "value": value, "source": source, "provenance": provenance});
}
function MediaRecordCard(props) {
  const {item, onRefresh, readOnly: readOnly = false} = props;
  const [editing, setEditing] = useState(false);
  const [title, setTitle] = useState(item.display_name);
  const [source, setSource] = useState(item.source_reference);
  const [description, setDescription] = useState(item.description);
  const [comment, setComment] = useState("");
  const [author, setAuthor] = useState("");
  const [claim_value, setClaim_value] = useState("");
  const [claim_source, setClaim_source] = useState("");
  const [claim_provenance, setClaim_provenance] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [confirm_delete, setConfirm_delete] = useState(false);
  const [comments_open, setComments_open] = useState(false);
  const [claims_open, setClaims_open] = useState(false);
  const [comment_form_open, setComment_form_open] = useState(false);
  const [claim_form_open, setClaim_form_open] = useState(false);
  async function save_edit() {
    setBusy(true);
    try {
      await __jacCallFunction("edit_media", {"media_id": item.id, "incident": item.incident, "display_name": title, "source_reference": source, "description": description});
      setEditing(false);
      await onRefresh();
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        setError(("Could not save media details: " + String(e)));
      } else {
        throw __jac_e;
      }
    }
    setBusy(false);
  }
  async function save_comment() {
    if (!comment.trim()) {
      setError("Write a comment first.");
      return;
    }
    setBusy(true);
    try {
      await __jacCallFunction("add_media_comment", {"media_id": item.id, "incident": item.incident, "body": comment, "author": author});
      setComment("");
      await onRefresh();
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        setError(("Could not add comment: " + String(e)));
      } else {
        throw __jac_e;
      }
    }
    setBusy(false);
  }
  async function save_assertion() {
    if ((!claim_value.trim() || !claim_source.trim())) {
      setError("Enter the reported location/source and its source.");
      return;
    }
    setBusy(true);
    try {
      await __jacCallFunction("add_media_assertion", {"media_id": item.id, "incident": item.incident, "assertion_type": "LOCATION_OR_SOURCE", "value": claim_value, "source": claim_source, "provenance": claim_provenance});
      setClaim_value("");
      setClaim_source("");
      setClaim_provenance("");
      await onRefresh();
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        setError(("Could not add claim: " + String(e)));
      } else {
        throw __jac_e;
      }
    }
    setBusy(false);
  }
  async function remove_record() {
    let removed;
    setBusy(true);
    try {
      removed = await __jacCallFunction("delete_media", {"media_id": item.id, "incident": item.incident});
      if (removed) {
        setConfirm_delete(false);
        await onRefresh();
      } else {
        setError("This media item was not found in the selected incident.");
      }
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        setError(("Could not delete media: " + String(e)));
      } else {
        throw __jac_e;
      }
    }
    setBusy(false);
  }
  return __jacJsx("article", {"className": "flex min-w-0 flex-col gap-3 rounded-xl border bg-card p-4 shadow-sm"}, [(item.data_url.startsWith("data:image/") && __jacJsx("img", {"src": item.data_url, "alt": item.display_name, "className": "h-48 w-full rounded-lg bg-muted object-contain"}, [])), ((item.data_url && !item.data_url.startsWith("data:image/")) && __jacJsx("div", {"className": "flex h-24 items-center justify-center rounded-lg border border-dashed bg-muted/30 p-3 text-center text-xs text-muted-foreground"}, [(("Preview unavailable: the file " + item.data_url) + " is not bundled with this demo. The record and its links are kept.")])), __jacJsx("div", {"className": "flex flex-wrap items-start justify-between gap-2"}, [__jacJsx("div", {"className": "min-w-0"}, [__jacJsx("h3", {"className": "break-words text-base font-semibold"}, [item.display_name]), __jacJsx("p", {"className": "text-xs text-muted-foreground"}, [((item.filename + " \u00b7 ") + item.incident)])]), (item.sha256 && __jacJsx("div", {"className": "flex gap-2"}, [__jacJsx(Button, {"size": "sm", "variant": "outline", "onClick": () => {
    setEditing(!editing);
  }}, ["Edit"]), __jacJsx(Button, {"size": "sm", "variant": "destructive", "onClick": () => {
    setConfirm_delete(true);
  }}, ["Delete"])]))]), (editing && __jacJsx("div", {"className": "flex flex-col gap-2 rounded-lg bg-muted/30 p-3"}, [__jacJsx("label", {"className": "flex flex-col gap-1 text-xs font-medium"}, ["Display name", __jacJsx("input", {"value": title, "onChange": e => {
    setTitle(e.target.value);
  }, "className": "h-9 rounded-md border border-input bg-background px-3 text-sm"}, [])]), __jacJsx("label", {"className": "flex flex-col gap-1 text-xs font-medium"}, ["Source or reference", __jacJsx("input", {"value": source, "onChange": e => {
    setSource(e.target.value);
  }, "className": "h-9 rounded-md border border-input bg-background px-3 text-sm"}, [])]), __jacJsx("label", {"className": "flex flex-col gap-1 text-xs font-medium"}, ["Description", __jacJsx("textarea", {"value": description, "onChange": e => {
    setDescription(e.target.value);
  }, "className": "min-h-16 rounded-md border border-input bg-background p-2 text-sm"}, [])]), __jacJsx(Button, {"size": "sm", "onClick": save_edit, "disabled": busy}, ["Save media details"])])), __jacJsx("p", {"className": "break-all text-xs text-muted-foreground"}, [("Source/reference: " + ((item.source_reference ? item.source_reference : "Not supplied")))]), __jacJsx("p", {"className": "whitespace-pre-wrap text-sm"}, [item.description]), ((!item.sha256 && !readOnly) && __jacJsx("p", {"className": "text-xs text-muted-foreground"}, ["Seeded demonstration record; no uploaded file was analyzed."])), (readOnly && __jacJsx("p", {"className": "text-xs text-muted-foreground"}, ["Generated exercise record: metadata only. The image file is not imported, so nothing was analyzed."])), (item.sha256 && __jacJsx("p", {"className": "break-all font-mono text-xs text-muted-foreground"}, [("SHA-256: " + item.sha256)])), ((item.duplicate_ids.length > 0) && __jacJsx("div", {"className": "rounded-md bg-muted p-3 text-xs"}, [__jacJsx("p", {"className": "font-semibold"}, [("Exact duplicate matches: " + String(item.duplicate_ids.length))]), __jacJsx("p", {"className": "mt-1"}, ["Byte-identical copies are not independent corroboration."]), __jacJsx("p", {"className": "mt-1"}, [("Related media IDs: " + item.duplicate_ids.join(", "))])])), __jacJsx("section", {"className": "border-t pt-2"}, [__jacJsx("button", {"type": "button", "onClick": () => {
    setComments_open(!comments_open);
  }, "aria-expanded": comments_open, "className": "flex w-full items-center justify-between rounded-md px-2 py-2 text-left text-sm font-medium transition-colors hover:bg-muted/50"}, [__jacJsx("span", {}, [(("Comments (" + String(item.comments.length)) + ")")]), __jacJsx("span", {"className": "text-muted-foreground"}, [(comments_open ? "\u2304" : "\u203a")])]), (comments_open && __jacJsx("div", {"className": "flex flex-col gap-2 px-2 pb-2"}, [(() => {
    let __jac_view_kids = [false];
    __jac_view_kids[0] = (() => {
      let __jac_view_kids_1 = [];
      for (const c of item.comments) {
        __jac_view_kids_1.push(__jacJsx("div", {"key": c.id, "className": "rounded-md bg-muted/40 p-2"}, [__jacJsx("p", {"className": "whitespace-pre-wrap text-sm"}, [c.body]), __jacJsx("p", {"className": "mt-1 text-xs text-muted-foreground"}, [((c.author + " \u00b7 ") + c.created_at)])]));
      }
      return __jac_view_kids_1;
    })();
    return __jacJsx(null, {}, __jac_view_kids);
  })(), ((!readOnly && !comment_form_open) && __jacJsx(Button, {"size": "sm", "variant": "outline", "onClick": () => {
    setComment_form_open(true);
  }}, ["+ Add comment"])), (comment_form_open && __jacJsx("div", {"className": "flex flex-col gap-2 rounded-md bg-muted/30 p-2"}, [__jacJsx("input", {"value": author, "onChange": e => {
    setAuthor(e.target.value);
  }, "placeholder": "Your name or source", "className": "h-9 rounded-md border border-input bg-background px-3 text-sm"}, []), __jacJsx("textarea", {"value": comment, "onChange": e => {
    setComment(e.target.value);
  }, "placeholder": "Add a comment", "className": "min-h-16 rounded-md border border-input bg-background p-2 text-sm"}, []), __jacJsx("div", {"className": "flex justify-end gap-2"}, [__jacJsx(Button, {"size": "sm", "variant": "outline", "onClick": () => {
    setComment("");
    setComment_form_open(false);
  }}, ["Cancel"]), __jacJsx(Button, {"size": "sm", "onClick": save_comment, "disabled": busy}, ["Save comment"])])]))]))]), __jacJsx("section", {"className": "border-t pt-2"}, [__jacJsx("button", {"type": "button", "onClick": () => {
    setClaims_open(!claims_open);
  }, "aria-expanded": claims_open, "className": "flex w-full items-center justify-between rounded-md px-2 py-2 text-left text-sm font-medium transition-colors hover:bg-muted/50"}, [__jacJsx("span", {}, [(("Claims (" + String(item.assertions.length)) + ")")]), __jacJsx("span", {"className": "text-muted-foreground"}, [(claims_open ? "\u2304" : "\u203a")])]), (claims_open && __jacJsx("div", {"className": "flex flex-col gap-2 px-2 pb-2"}, [(() => {
    let __jac_view_kids_2 = [false];
    __jac_view_kids_2[0] = (() => {
      let __jac_view_kids_3 = [];
      for (const claim of item.assertions) {
        __jac_view_kids_3.push(__jacJsx("div", {"key": claim.id, "className": "rounded-md bg-muted/40 p-2"}, [__jacJsx("p", {"className": "text-sm"}, [claim.value]), __jacJsx("p", {"className": "mt-1 text-xs text-muted-foreground"}, [((((claim.source + " \u00b7 ") + claim.asserted_at) + " \u00b7 ") + claim.status)]), __jacJsx("p", {"className": "text-xs text-muted-foreground"}, [claim.provenance])]));
      }
      return __jac_view_kids_3;
    })();
    return __jacJsx(null, {}, __jac_view_kids_2);
  })(), ((!readOnly && !claim_form_open) && __jacJsx(Button, {"size": "sm", "variant": "outline", "onClick": () => {
    setClaim_form_open(true);
  }}, ["+ Add claim"])), (claim_form_open && __jacJsx("div", {"className": "flex flex-col gap-2 rounded-md bg-muted/30 p-2"}, [__jacJsx("input", {"value": claim_value, "onChange": e => {
    setClaim_value(e.target.value);
  }, "placeholder": "Reported place or source", "className": "h-9 rounded-md border border-input bg-background px-3 text-sm"}, []), __jacJsx("input", {"value": claim_source, "onChange": e => {
    setClaim_source(e.target.value);
  }, "placeholder": "Who reported this?", "className": "h-9 rounded-md border border-input bg-background px-3 text-sm"}, []), __jacJsx("input", {"value": claim_provenance, "onChange": e => {
    setClaim_provenance(e.target.value);
  }, "placeholder": "Provenance or context", "className": "h-9 rounded-md border border-input bg-background px-3 text-sm"}, []), __jacJsx("p", {"className": "text-xs text-muted-foreground"}, ["Claims are attributed reports, not verified location facts."]), __jacJsx("div", {"className": "flex justify-end gap-2"}, [__jacJsx(Button, {"size": "sm", "variant": "outline", "onClick": () => {
    setClaim_value("");
    setClaim_source("");
    setClaim_provenance("");
    setClaim_form_open(false);
  }}, ["Cancel"]), __jacJsx(Button, {"size": "sm", "onClick": save_assertion, "disabled": busy}, ["Save claim"])])]))]))]), (confirm_delete && __jacJsx("div", {"role": "alertdialog", "className": "flex flex-wrap items-center gap-2 rounded-md border border-destructive/40 bg-destructive/5 p-3 text-sm"}, [__jacJsx("span", {"className": "mr-auto"}, ["Delete this media item and its comments, claims, signals, and duplicate links?"]), __jacJsx(Button, {"size": "sm", "variant": "outline", "onClick": () => {
    setConfirm_delete(false);
  }}, ["Cancel"]), __jacJsx(Button, {"size": "sm", "variant": "destructive", "onClick": remove_record, "disabled": busy}, ["Confirm delete"])])), (error && __jacJsx("p", {"role": "alert", "className": "text-sm text-destructive"}, [error]))]);
}
function MediaTab(props) {
  const {snapshot, onRefresh} = props;
  const [query, setQuery] = useState("");
  const [source, setSource] = useState("");
  const [selected_name, setSelected_name] = useState("");
  const [preview, setPreview] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  let incident = snapshot.incident_name;
  let media_items = snapshot.media_records;
  async function refresh_media() {
    await onRefresh();
  }
  function handle_file(e) {
    let file = e.target.files[0];
    if (file) {
      if (!_jac.poly.call(file.type, "startswith", "image/")) {
        setError("Choose a PNG, JPEG, GIF, or WebP image.");
        return;
      }
      if ((file.size > 6_000_000)) {
        setError("Choose an image under 6 MB.");
        return;
      }
      setSelected_name(String(file.name));
      let reader = Reflect.construct(window.FileReader, []);
      reader.onload = event => {
        setPreview(event.target.result);
        setError("");
      };
      reader.onerror = event => {
        setError("The browser could not read this image. Choose it again.");
      };
      reader.readAsDataURL(file);
    }
  }
  async function do_upload() {
    if (!incident.trim()) {
      setError("Choose the incident before uploading.");
      return;
    }
    if (!source.trim()) {
      setError("Enter the supplied source or reference.");
      return;
    }
    if (!preview) {
      setError("Choose an image to preview before uploading.");
      return;
    }
    setBusy(true);
    try {
      await __jacCallFunction("upload_image", {"incident": incident, "filename": selected_name, "source_reference": source, "data_url": preview});
      setPreview("");
      setSelected_name("");
      setSource("");
      setNotice("Image saved as a Media record. Exact matches use SHA-256 within this incident.");
      await refresh_media();
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        setError(("Upload failed: " + String(e)));
      } else {
        throw __jac_e;
      }
    }
    setBusy(false);
  }
  async function do_duplicate_check() {
    setBusy(true);
    try {
      await __jacCallFunction("check_media_duplicates", {"incident": incident});
      setNotice("Exact duplicate relationships refreshed for this incident.");
      await onRefresh();
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        setError(("Duplicate check failed: " + String(e)));
      } else {
        throw __jac_e;
      }
    }
    setBusy(false);
  }
  let q = query.trim().toLowerCase();
  let records = media_items.filter(m => ((((((((q === "") || m.filename.toLowerCase().includes(q)) || m.display_name.toLowerCase().includes(q)) || m.source_reference.toLowerCase().includes(q)) || m.description.toLowerCase().includes(q)) || m.incident.toLowerCase().includes(q)) || m.assertions.map(a => ((a.value + " ") + a.source)).join(", ").toLowerCase().includes(q)) || m.comments.map(c => ((c.body + " ") + c.author)).join(", ").toLowerCase().includes(q))).map(m => m);
  return __jacJsx("div", {"className": "flex flex-col gap-5"}, [__jacJsx(SectionHeading, {"title": "Incident media", "subtitle": "One incident-scoped collection for uploaded files, seeded media, sources, comments, and attributed claims."}, []), (snapshot.is_corpus && __jacJsx("p", {"className": "rounded-md border border-border bg-muted/30 p-3 text-sm text-muted-foreground"}, [(String(media_items.length) + " generated exercise media records with their descriptions and captions. Image files are not imported, so uploads, duplicate checks and edits are off for this incident.")])), (!snapshot.is_corpus && __jacJsx("section", {"className": "grid gap-4 rounded-xl border bg-card p-4 shadow-sm md:grid-cols-2 md:p-6"}, [__jacJsx("div", {"className": "flex flex-col gap-3"}, [__jacJsx("h2", {"className": "text-lg font-semibold"}, ["Upload an image"]), __jacJsx("p", {"className": "text-sm text-muted-foreground"}, ["Uploads become canonical Media records. SHA-256 is calculated from image bytes on the server."]), __jacJsx("label", {"className": "flex flex-col gap-1 text-sm font-medium"}, ["Incident", __jacJsx("input", {"value": incident, "readOnly": true, "className": "h-10 rounded-md border bg-muted px-3 font-normal"}, [])]), __jacJsx("label", {"className": "flex flex-col gap-1 text-sm font-medium"}, ["Supplied source/reference", __jacJsx("input", {"value": source, "onChange": e => {
    setSource(e.target.value);
  }, "placeholder": "Reporter, URL, or source note", "className": "h-10 rounded-md border border-input bg-background px-3 font-normal"}, [])]), __jacJsx("label", {"className": "flex flex-col gap-1 text-sm font-medium"}, ["Image file", __jacJsx("input", {"type": "file", "accept": "image/png,image/jpeg,image/gif,image/webp", "onChange": handle_file, "className": "rounded-md border p-2 text-sm"}, [])]), (selected_name && __jacJsx("p", {"className": "text-xs text-muted-foreground"}, [selected_name])), __jacJsx(Button, {"onClick": do_upload, "disabled": busy}, ["Upload to incident media"])]), __jacJsx("div", {"className": "flex min-h-48 items-center justify-center rounded-lg border border-dashed bg-muted/30 p-3"}, [(preview && __jacJsx("img", {"src": preview, "alt": "Selected image preview", "className": "max-h-72 max-w-full object-contain"}, [])), (!preview && __jacJsx("p", {"className": "text-sm text-muted-foreground"}, ["Choose an image to preview it before upload."]))])])), (error && __jacJsx("p", {"role": "alert", "className": "rounded-md border border-destructive/40 bg-destructive/5 p-3 text-sm text-destructive"}, [error])), (notice && __jacJsx("p", {"role": "status", "className": "rounded-md border border-primary/30 bg-primary/5 p-3 text-sm"}, [notice])), __jacJsx("section", {"className": "flex flex-col gap-4 rounded-xl border bg-card p-4 shadow-sm md:p-6"}, [__jacJsx("div", {"className": "flex flex-wrap items-end justify-between gap-3"}, [__jacJsx("div", {}, [__jacJsx("h2", {"className": "text-lg font-semibold"}, ["Media collection"]), __jacJsx("p", {"className": "text-sm text-muted-foreground"}, ["Search filename, display name, source, description, claim, or comment."])]), (!snapshot.is_corpus && __jacJsx(Button, {"variant": "outline", "onClick": do_duplicate_check, "disabled": busy}, ["Check exact duplicates"]))]), __jacJsx("input", {"type": "search", "value": query, "onChange": e => {
    setQuery(e.target.value);
  }, "placeholder": "Search this incident's media", "className": "h-10 w-full rounded-md border border-input bg-background px-3 text-sm focus-visible:ring-2 focus-visible:ring-ring"}, []), (_jac.list.eq(records, []) && __jacJsx("div", {"className": "rounded-lg border border-dashed bg-muted/20 p-8 text-center"}, [__jacJsx("h3", {"className": "font-medium"}, ["No matching media"]), __jacJsx("p", {"className": "mt-1 text-sm text-muted-foreground"}, ["Upload an image or change the search."])])), __jacJsx("div", {"className": "grid gap-4 lg:grid-cols-2"}, [(() => {
    let __jac_view_kids_4 = [false];
    __jac_view_kids_4[0] = (() => {
      let __jac_view_kids_5 = [];
      for (const item of records) {
        __jac_view_kids_5.push(__jacJsx(MediaRecordCard, {"key": item.id, "item": item, "onRefresh": refresh_media, "readOnly": snapshot.is_corpus}, []));
      }
      return __jac_view_kids_5;
    })();
    return __jacJsx(null, {}, __jac_view_kids_4);
  })()])])]);
}
/*jac:refresh-boundary*/;
export {MediaRecordCard, MediaTab};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:upload_image": {"is_writer": true, "touches": ["*"]}, "func:list_incident_media": {"is_writer": false, "touches": ["*"]}, "func:check_media_duplicates": {"is_writer": true, "touches": ["*"]}, "func:edit_media": {"is_writer": true, "touches": ["*"]}, "func:delete_media": {"is_writer": true, "touches": ["*"]}, "func:add_media_comment": {"is_writer": true, "touches": ["*"]}, "func:add_media_assertion": {"is_writer": true, "touches": ["*"]}}); };
//# sourceMappingURL=MediaTab.js.map
